























































































import Vue from "vue";
import { Component } from "vue-property-decorator";
import Request from "@/models/checkRequest/request";
import { mapGetters, mapState } from "vuex";
import {
  DownloadIcon,
  LoaderIcon,
  MoreVerticalIcon,
  Trash2Icon,
  // @ts-ignore
} from "vue-feather-icons";
import ListItem from "@/components/url/list-item.vue";
import Queue from "@/components/queue/queue.vue";
import AddUrls from "@/views/add-urls.vue";
import {
  CLEAR_REQUESTS,
  DELETE_REQUEST,
  SET_ACTIVE_REQUEST_ID,
} from "@/store/mutation-types";

@Component({
  components: {
    "uc-queue": Queue,
    "uc-add-urls": AddUrls,
    DownloadIcon,
    ListItem,
    LoaderIcon,
    MoreVerticalIcon,
    Trash2Icon,
  },
  computed: {
    ...mapState("projects", ["activeRequestId", "queueBusy"]),
    ...mapGetters("projects", [
      "requests",
      "filteredRequests",
      "requestsReady",
    ]),
  },
})
export default class List extends Vue {
  checkList: Array<string> = [];
  isIndeterminate = false;

  // mapState + mapGetters
  queueBusy!: boolean;
  activeRequestId!: string;
  requests!: Array<Request>;
  filteredRequests!: Array<Request>;
  requestsReady!: Array<Request>;

  get loaderTooltip(): string {
    return `${this.requestsReady.length} of ${this.requests.length} ready`;
  }

  get queuePercentage() {
    if (!this.requests.length) {
      return 0;
    }

    return (this.requestsReady.length / this.requests.length) * 100;
  }

  get requestIds(): Array<string> {
    if (!this.filteredRequests) {
      return [];
    }

    return this.filteredRequests.map((ch) => ch.id);
  }

  get checkAll(): boolean {
    return (
      this.checkList.length === this.requestIds.length &&
      this.requestIds.length > 0
    );
  }

  handleCheckAllChange(val: any) {
    this.checkList = val ? this.requestIds : [];
    this.isIndeterminate = false;
  }

  handleCheckListChange(value: any) {
    let checkedCount = value.length;
    this.isIndeterminate =
      checkedCount > 0 && checkedCount < this.requestIds.length;
  }

  deleteRequest(id: string) {
    this.$confirm(`Are you sure you want to delete this url?`, "Delete url", {
      confirmButtonText: "Yes, delete",
      cancelButtonText: "Cancel",
      type: "warning",
    })
      .then(() => {
        this.$store.commit(`projects/${DELETE_REQUEST}`, id);
      })
      .catch(() => {
        // don't do anything, just handle the promise
      });
  }

  deleteRequests() {
    if (this.checkList.length === 0) {
      this.deleteAll();
    }
    //
    // User made a selection
    if (this.checkList.length > 0) {
      this.deleteSelected();
    }
  }

  deleteAll() {
    this.$confirm(`Are you sure you want to delete all urls?`, "Delete urls", {
      confirmButtonText: "Yes, delete everything",
      cancelButtonText: "Cancel",
      type: "warning",
    })
      .then(() => {
        this.$store.commit(`projects/${CLEAR_REQUESTS}`);
        this.$message({
          message: "All urls have been deleted.",
          type: "success",
        });
      })
      .catch(() => {
        // don't do anything, just handle the promise
      });
  }

  deleteSelected() {
    this.$confirm(
      `Are you sure you want to delete the selected urls?`,
      "Delete urls",
      {
        confirmButtonText: "Yes, delete",
        cancelButtonText: "Cancel",
        type: "warning",
      }
    )
      .then(() => {
        this.checkList.forEach((id) => {
          this.$store.commit(`projects/${DELETE_REQUEST}`, id);
        });

        this.$message({
          message: "Selected urls have been deleted.",
          type: "success",
        });
      })
      .catch(() => {
        // don't do anything, just handle the promise
      });
  }

  setActiveRequestId(id: string) {
    this.$store.commit(`projects/${SET_ACTIVE_REQUEST_ID}`, id);
  }
}
